import React from "react";
import { HeroImage } from "../../components/Image/Image.styled";
import { useTranslation } from "react-i18next";
import Section from "../../components/Section/Section";
import {
  ContactLinks,
  ContactLink,
  ContactItem,
  ContactDividerLine,
} from "./ContactPage.styled";

import GenaralImg from "../../assets/pages/contact.jpg";
import useDevice from "../../hooks/useDevice";
import TenYearsSection from "../../components/TenYearsSection/TenYearsSection";
import { addressContactInfo, basicContactInfo } from "../../constants/contact";

const i18nKey = "pages.contact";

const ContactPage: React.FC = () => {
  const { t } = useTranslation();
  const { isMobile, isTablet } = useDevice();

  const sectionStyle = isMobile || isTablet ? { gap: "16px" } : {};
  return (
    <>
      <HeroImage
        src={GenaralImg}
        alt={t(`${i18nKey}.title`)}
        $position={"center 35%"}
      />
      <Section
        withBackgroundImg={false}
        header={i18nKey ? t(`${i18nKey}.title`) : ""}
        sectionStyle={sectionStyle}
      >
        <ContactLinks>
          {basicContactInfo.map((item, index) => {
            return (
              <ContactItem key={index}>
                <item.Icon />
                <ContactLink target={item.target} href={item.href}>
                  {item.text}
                </ContactLink>
              </ContactItem>
            );
          })}
        </ContactLinks>
        <ContactDividerLine />
        <ContactLinks style={{marginTop: 0}}>
          {addressContactInfo.map((item, index) => {
            return (
              <ContactItem key={index}>
                <item.Icon />
                <ContactLink target={item.target} href={item.href}>
                  {item.text}
                </ContactLink>
              </ContactItem>
            );
          })}
        </ContactLinks>
      </Section>
      <TenYearsSection />
    </>
  );
};

export default ContactPage;
